import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

/** 数据概览：用户/交易/财务概况 + 三张趋势图（后端已整体并行聚合 + 缓存） */
export function dashboardOverview(data) {
  return axios.post(`${base.url}/business/dashboard/overview`, qs.stringify(data || {}))
}
